import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'category'>,
  Pick<ReqCreateOrUpdateChallenge, 'category'>
> = ({ category }) => {
  return { category };
};

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'category'>,
  Pick<ChallengeFormType, 'category'>
> = ({ category }) => ({ category });
